import { register } from 'swiper/element/bundle'

export default function registerSwiperUtil () {
  register()
}
